import script from "./dashbTasks.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashbTasks.vue?vue&type=script&setup=true&lang=ts"

import "./dashbTasks.vue?vue&type=style&index=0&id=d10649cc&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d10649cc"]])

export default __exports__